import { useContext,  useEffect } from "react"
import { MixtapePageContext } from "./MixtapePageContainer"
import MixtapeIcon from "../../icons/MixtapeIcon"
import MixtapeActions from "./MixtapeActions"

const MixtapeDetails = () => {
  const {
    user_role,
    is_owner,
    mixtapeDetails,
    mixtapeSerializer,
    setMixtapeDetails
  } = useContext(MixtapePageContext)
  const { updated_at, created_at } = mixtapeDetails
  
  // Listen for "mixtape:updated" events dispatched from Stimulus to update the displayed mixtape details without reloading the page
  useEffect(() => {
    const handler = (e) => {
      const { id, name, description } = e.detail || {}
      if (id && id !== mixtapeSerializer.id) return
      setMixtapeDetails((prev) => ({
        ...prev,
        name: name ?? prev.name,
        description: description ?? prev.description,
      }))
    }
    document.addEventListener("mixtape:updated", handler)
    return () => document.removeEventListener("mixtape:updated", handler)
  }, [mixtapeSerializer.id, setMixtapeDetails])

  var updated_at_array = new Date(updated_at).toString().split(" ")
  var readableUpdatedAt = `${updated_at_array[1]} ${updated_at_array[2]} ${updated_at_array[3]}`
  const htmlSafe = (text) => text.replace(/<\/?[^>]+(>|$)/g, "")

  return (
    <>
      <header id="mm-mixtape-landing">
        <div className="heading">
          <div className="contain">
            <div id="mixtape-default">
              <div className="mixtape-image-wrapper">
                {mixtapeDetails.staff_pick && mixtapeDetails.image ? (
                  <img src={mixtapeDetails.image} alt={mixtapeDetails.name ?? mixtapeSerializer.name} className="mixtape-image"/>
                ) : (
                  <MixtapeIcon />
                )}
              </div>
              <div className="heading">
                <div className="info">
                  <h1>{mixtapeDetails.name ?? mixtapeSerializer.name}</h1>
                  <p className="curetor">
                    Curated by 
                    <span> {mixtapeDetails.owner_name}</span>
                  </p>
                  
                  <div className="stats">
                    <span className="song-count">{mixtapeDetails.song_version_count} Songs</span>
                    <span className="runtime">Runtime: {mixtapeDetails.runtime}</span>
                  </div>

                  <p className="description">{mixtapeDetails.description != "" && htmlSafe(mixtapeDetails.description)}</p>

                  {mixtapeDetails.collaborative_in_some_way && mixtapeDetails.collaborators != "" && (
                    <p className="collaborators">Collaborators: {mixtapeDetails.collaborators}</p>
                  )}

                  <p className="last-updated">
                    Last Updated <time dateTime={mixtapeDetails.updated_at}>{readableUpdatedAt}</time>
                  </p>
                </div>
                <MixtapeActions/>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  )
}

export default MixtapeDetails
